module.exports = __webpack_public_path__ + "static/media/intro02.00f4898c.png";